var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.352,
    height: 112,
    viewBox: "0 0 183.352 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(0,63,162,0.05);}.b,.d,.h{fill:none;stroke-miterlimit:10;}.b,.d{stroke:#003fa2;stroke-width:4px;}.b{stroke-linecap:square;}.c{fill:#ccd1e7;}.e{fill:#0081c6;}.f{fill:#001c85;}.g{fill:#003fa2;}.h{stroke:#fff;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.223,64.86H214.862l-64.712,112H31.51Z",
    transform: "translate(-31.51 -64.86)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.676 13.999)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 80,
    transform: "translate(-20.601 82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.088,52.56A12.04,12.04,0,0,0,20.4,42.939h0a12.034,12.034,0,0,0-9.611-3.7c-3.221.352-7.937,21.876-7.937,21.876",
    transform: "translate(2.93 12.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5,72.667s4.319-17.652,8-21.333L59.572,4.761a9.429,9.429,0,0,1,13.333,0h0a9.429,9.429,0,0,1,0,13.333L26.333,64.667C22.652,68.348,5,72.667,5,72.667Z",
    transform: "translate(1 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49,43.333l16-16L59.667,22",
    transform: "translate(15.667 6.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M10.792,39.241a12.034,12.034,0,0,1,9.611,3.7h0a12.04,12.04,0,0,1,3.685,9.621",
    transform: "translate(2.931 12.395)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M39.541,64.86H55.6l-8.031,13.9H31.51Z",
    transform: "translate(-8.605 -22.759)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M34.394,64.86h5.768l-2.884,4.992H31.51Z",
    transform: "translate(15.49 -18.305)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M37.247,64.86H48.721l-5.737,9.93H31.51Z",
    transform: "translate(15.489 -36.877)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M36.89,64.86H47.65l-5.38,9.311H31.51Z",
    transform: "translate(118.042 -55.516)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M34.205,64.86H39.6l-2.7,4.664H31.51Z",
    transform: "translate(135.473 -61.438)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.022 79.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M45.377,64.86H73.111l-13.867,24H31.51Z",
    transform: "translate(-31.51 -64.86)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.004 8.442)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "h",
    y2: 8,
    transform: "translate(4)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x2: 8,
    transform: "translate(0 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSignature);
export default __webpack_public_path__ + "static/media/Illustration_Signature.e0314a781c1d8699cacc5af57dc8ef21.svg";
export { ForwardRef as ReactComponent };